const API_URL = 'https://api.usf.digitaltriumph.co.in/api/v1/';

export default API_URL;
